import React, { useState } from 'react';
import { post } from 'axios';
import PropTypes from 'prop-types';

import ModalContainer from 'components/ModalContainer';

import FilledButton from 'components/Buttons/FilledButton';
import If from 'components/If';
import Switch from 'components/FormGroup/Switch';
import Tooltip from 'components/Informations/Tooltip';

import endpoints from 'services/endpoints';

import privilegesData from '../../ManagePrivileges/privileges.data';

import * as S from './styles';

const { updatePrivileges } = endpoints;

const EditPrivilege = ({
  employee,
  isOpen,
  setIsOpen,
  observer,
  setIsLoading,
  toastVisibility,
  toastInfos,
}) => {
  const { permissions, funcao, id_funcao, userID } = employee;
  const [employeePermissions, setEmployeePermissions] = useState(permissions);

  function toggleSwitchChecked(routeId) {
    if (employeePermissions.includes(routeId)) {
      const filteredPermissions = employeePermissions.filter(
        permission => permission !== routeId,
      );

      return setEmployeePermissions(filteredPermissions);
    }

    return setEmployeePermissions([...employeePermissions, routeId]);
  }

  async function handleSubmit() {
    setIsLoading(true);

    await post(updatePrivileges, {
      id_funcao,
      acessos: employeePermissions,
      id_usr_in: userID,
      id_usr_up: userID,
    });
    observer(current => !current);
    toastVisibility(true);
    toastInfos({
      type: 'success',
      message: 'Privilégios atualizados com sucesso',
    });

    setIsOpen(false);
    setIsLoading(false);
  }

  return (
    <ModalContainer
      headText={`Editar privilégio de ${funcao}`}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    >
      {privilegesData.map((privilege, index) => (
        <S.PermissionGroup key={index}>
          <S.GroupTitle>{privilege.routes[0].group}</S.GroupTitle>

          {privilege.routes.map(route => (
            <S.Permission key={route.permissionId}>
              <S.PermissionName>
                <p>{route.route}</p>

                <If condition={route.info}>
                  <Tooltip position="right">{route.info}</Tooltip>
                </If>
              </S.PermissionName>

              <Switch
                isChecked={employeePermissions.includes(route.permissionId)}
                onChange={() => toggleSwitchChecked(route.permissionId)}
                isDisabled={route.disabled}
              />
            </S.Permission>
          ))}
        </S.PermissionGroup>
      ))}

      <S.ButtonsWrapper>
        <FilledButton
          text="Cancelar"
          buttonClass="cancel"
          handleClick={() => setIsOpen(false)}
        />
        <FilledButton
          text="Salvar"
          buttonClass="confirm"
          handleClick={handleSubmit}
        />
      </S.ButtonsWrapper>
    </ModalContainer>
  );
};

export default EditPrivilege;

EditPrivilege.propTypes = {
  employee: PropTypes.shape({
    permissions: PropTypes.arrayOf(PropTypes.string),
    funcao: PropTypes.string,
    id_funcao: PropTypes.number,
    userID: PropTypes.number,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  observer: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  toastVisibility: PropTypes.bool.isRequired,
  toastInfos: PropTypes.objectOf(
    PropTypes.shape({
      type: PropTypes.string,
      message: PropTypes.string,
      autoClose: PropTypes.number,
    }),
  ).isRequired,
};
